module.exports = __webpack_public_path__ + "images/emoji/pig_nose.635537e0fbbb8c98ac4c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pig_nose.png
// module id = zXxd
// module chunks = 2